import React from 'react';
import { useLanguage } from '../context/LanguageContext';

/**
 * Footer Component
 * Features:
 * - Simple, clean design
 * - Dark background
 * - Copyright with current year
 * - Developer credits with link
 */
const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-primary-navy text-white py-12 sm:py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Main Content */}
        <div className="text-center mb-8">
          <p className="text-base sm:text-lg mb-4 opacity-90">
            {t('footer.description')}
          </p>
        </div>

        {/* Copyright and Developer Row */}
        <div className="border-t border-white/20 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          {/* Copyright */}
          <p className="text-sm opacity-70">
            © {currentYear} Royal Rooms B&B. {t('footer.rights')}
          </p>

          {/* Developer */}
          <p className="text-sm opacity-70">
            Developed by{' '}
            <a
              href="https://wattoo.uk"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white font-semibold hover:text-primary-bronze transition-all duration-300 hover:scale-110 inline-block hover:drop-shadow-[0_0_10px_rgba(100,66,34,0.8)]"
            >
              Wattoo Techs
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

